import { useAuthState } from './useAuthState'

export const useIsAccountPaused = (): boolean => {
  const { jwt } = useAuthState()

  return jwt?.org?.status === 'CHURNED'
}
